import { AsyncAction } from "@/Common/Api/AsyncActions/AsyncAction";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ConsentStatus } from "@/Patient/Models/Consent/ConsentEnum";
import { ConsentProgramResponse } from "@/Patient/Models/Consent/ConsentModel";

class ConsentAction extends AsyncAction {
    public async getConsentPrograms(): Promise<ConsentProgramResponse> {
        return this.postAsync<ConsentProgramResponse>(ServerOperations.Server.Myle_LoadConsentPrograms, {});
    }

    public async accessWithoutConsentPermission(patientContactId: string, consentProgramCode: string): Promise<{ HasAccess: boolean, ClaimId: string }> {
        return this.postAsync<{ HasAccess: boolean, ClaimId: string }>(
            ServerOperations.Server.Myle_Patient_CheckAccessWithoutConsentPermission,
            {
                PatientContactId: patientContactId,
                ConsentProgramCode: consentProgramCode
            }
        );
    }

    public async saveAccessWithoutConsent(patientContactFacetId: string, motiveLookupId: string, comments: string, consentProgramId: number): Promise<{ ClaimId: string }> {
        return this.postAsync<{ ClaimId: string }>(ServerOperations.Server.Myle_Patient_AddAccessWithoutConsent, {
            PatientContactFacetId: patientContactFacetId,
            MotiveLookupId: motiveLookupId,
            Comments: comments,
            ConsentProgramId: consentProgramId
        });
    }

    public async saveConsent(patientContactId: string, consentProgramId: number, givenBy: string, consentDate: Date, status: ConsentStatus): Promise<void> {
        return this.postAsync<null>(ServerOperations.Server.Myle_Patient_AddConsentProgramHistory, {
            PatientContactId: patientContactId,
            ConsentProgramId: consentProgramId,
            GivenBy: givenBy,
            ConsentDate: consentDate,
            Status: status
        });
    }
}

export { ConsentAction };
